/*
 *
 * Package: `@dbh/hdp-page-constants`.
 *
 */const HDP_PAGE_SIDE_PADDINGS=Object.freeze({xs:"sp6",md:"sp9",lg:"sp13",xl:"sp6"});

export { HDP_PAGE_SIDE_PADDINGS };
